// english

export default {
  user_auth_title: '用户授权',
  user_auth_role: '用户角色',
  user_auth_customer_site_label: '客户/站点授权',
  // btn
  user_btn_change_password: '修改密码',

  // conifrm
  user_confirm_save_title: '确定保存?',

  user_confirm_disabled_title: '确定禁用该用户?',
  user_confirm_content: '用户名: {name}',
  user_confirm_delete_title: '确定删除该用户?',

  // table
  user_table_userName: '用户名',
  user_table_nickName: '昵称',
  user_table_email: 'Email',
  user_table_belonged_customer: '隶属客户',

  // form
  user_form_avatar: '头像',
  user_form_role: '角色',
  user_form_role_all: '所有角色',
  user_form_role_placeholder: '请选择一个角色',
  user_form_userName_placeholder: '请输入用户名',
  user_form_userName_help:
    '只允许字符串、数字、字母、下划线、6-32位数字，保存后不能修改，请谨慎填写!',
  user_form_nickName_placeholder: '请输入昵称',
  user_form_owner: '隶属客户',
  user_form_owner_placeholder: '请选择一个客户',
  user_form_email_placeholder: '请输入E-mail',
  user_form_site_max: '最大允许创建站点数',
  user_form_site_max_placeholder: '请输入最大允许创建站点数',
  user_form_password: '密码',
  user_form_password_placeholder: '请输入密码',

  user_privacy_title: '隐私政策',
  user_privacy_check:
    '我已阅读并同意MBE设备运维平台的 隐私政策 （该隐私政策后续您可在 个人中心 处查看）',
};
